import { useTranslation } from 'react-i18next';

import { TimelineRowFrame } from './experiment-timeline-row-frame';

/** Greyed checkpoint rows drawn in the placeholder — enough to read as a
 *  multi-step timeline without implying any specific checkpoint count. */
const PLACEHOLDER_ROWS = 5;

/**
 * Static structural placeholder for the Timeline card — shown when the timeline
 * endpoint has no data to return (pre-launch experiments, or a 404 before the
 * run is mirrored into analytics). Renders the timeline's *shape* (node +
 * connector + label rows) in a muted, non-animated state plus a caption, so the
 * tab reads as "not started yet" rather than broken. Deliberately renders NO
 * checkpoint name / status / day text — nothing fabricated reaches the screen.
 */
export function ExperimentTimelinePlaceholder() {
  const { t } = useTranslation('experiments');

  return (
    <div>
      {/* Decorative skeleton frame — hidden from the a11y tree; the caption
          below carries the meaning. Static (no pulse) so it doesn't read as a
          loading state. */}
      <div aria-hidden="true">
        {Array.from({ length: PLACEHOLDER_ROWS }).map((_, idx) => (
          <TimelineRowFrame key={idx}>
            <div className="border-muted-foreground/20 bg-muted/30 h-12 w-12 justify-self-center rounded-full border-2 border-dashed" />
            <div className="space-y-2">
              <div className="bg-muted/50 h-3 w-12 rounded" />
              <div className="bg-muted/50 h-4 w-40 rounded" />
            </div>
            <div className="bg-muted/50 h-6 w-20 rounded-full" />
            <div className="bg-muted/50 h-4 w-full rounded" />
          </TimelineRowFrame>
        ))}
      </div>
      <p
        role="status"
        aria-live="polite"
        className="text-muted-foreground border-t px-6 py-5 text-center text-sm"
      >
        {t('detail.timelinePlaceholder')}
      </p>
    </div>
  );
}
